export default "__VITE_ASSET__939befb3__"